import React from 'react';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../data/services';
export function Testimonials() {
  return <section id="reviews" className="w-full bg-brand-navy py-16 lg:py-24" data-id="element-202" data-mp="3kqw3kih68yf2">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-203" data-mp="3fym6mihn2y3a">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-204" data-mp="3b0knxyo4l0sc">
          <div data-id="element-205" data-mp="3ayqd5d6kip1z">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-light" data-id="element-206" data-mp="36ypo6yluevgo">
              Reviews
            </p>
            <h2 className="mt-3 font-display text-3xl leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-207" data-mp="31zmqjz86zriq">
              WHAT LINCOLN SAYS.
            </h2>
          </div>
          <div className="flex items-center gap-2" data-id="element-208" data-mp="2s28cg69qretl">
            <div className="flex" aria-hidden="true" data-id="element-209" data-mp="2s3jjqg2eb4pg">
              {[0, 1, 2, 3, 4].map(i => <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" data-id="element-210" data-mp="v8nar7dvcfh1" />)}
            </div>
            <span className="text-sm font-semibold text-white/80" data-id="element-211" data-mp="q8iw7mwitutg">
              5.0 average across 40+ jobs
            </span>
          </div>
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-212" data-mp="m5sz6h4kg0o5">
          {testimonials.map(item => <li key={item.name} className="flex flex-col rounded-3xl bg-white/[0.06] p-7 ring-1 ring-white/10" data-id="element-213" data-mp="7927ku14vt93">
              <Quote className="h-7 w-7 text-brand-blue" aria-hidden="true" data-id="element-214" data-mp="zwfv61ixzcgj" />
              <blockquote className="mt-4 flex-1 text-base leading-relaxed text-white/90" data-id="element-215" data-mp="zyiuxd9wcjyg">
                {item.quote}
              </blockquote>
              <div className="mt-6 border-t border-white/10 pt-4" data-id="element-216" data-mp="q7eh4gvyj557">
                <p className="text-sm font-bold text-white" data-id="element-217" data-mp="v5pswx5tbpq2">{item.name}</p>
                <p className="text-xs font-semibold text-white/55" data-id="element-218" data-mp="v3wh73gcefb7">
                  {item.location} · {item.service}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}